import { render, staticRenderFns } from "./AddEstimates.vue?vue&type=template&id=ae771e1e&scoped=true"
import script from "./AddEstimates.vue?vue&type=script&lang=js"
export * from "./AddEstimates.vue?vue&type=script&lang=js"
import style0 from "./AddEstimates.vue?vue&type=style&index=0&id=ae771e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae771e1e",
  null
  
)

export default component.exports